import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders  } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CallbackSigninService {
  [x: string]: any;

  constructor(
    private http: HttpClient
  ) { }

  oauth2Code (code: any,_channel: any, channelType?:any) {
    const apiUrl = '/api/oauth2Code';
    const body = {
      code: code,
      redirectUri: environment.idsLogin.redirect_url,
      clientType: environment.idsLogin.channels[_channel as keyof typeof environment.idsLogin.channels].clientType
    };
    // console.log('body',body);

    let header = new HttpHeaders({
      'Content-Type': 'application/json',
      'channeltype': channelType
    })

    // console.log('header',header);
    const httpOptions = {
      headers: header
    }

    return this.http.post(apiUrl, body, httpOptions).toPromise();
  }

  loginAis (token: string) {
    const apiUrl = '/api/login-ais';
    const body = {
      applicationName: environment.idsApplicationName,
      tokenID: token,
      redirectURL: environment.idsLogin.redirect_url
    }
    return this.http.post(apiUrl,body).toPromise();
  }

  configMC(token : any) {
    const apiUrl = '/api/easyapp/configMC';
    const body = {
      operation: 'query',
      nameconfig: 'newLogin'
    };
    const httpOptions = {
      headers: new HttpHeaders({
        'x-authorization': 'Bearer '+ token
      })
    };
    return this.http.post(apiUrl, body, httpOptions).toPromise();
  }

  public logOutToken(): Promise<any> {
    // try{
      const apiUrl = '/api/logout-session';
      return this.http.get(apiUrl,{}).toPromise();
    // } catch(err){
    //   throw(err)
    // }
  }

  getConfigInactiveTimeout (role:string) {
    const apiUrl = '/api/get-config-inactive-timeout';
    const body = { role:  role }
    return this.http.post(apiUrl,body).toPromise();
  }

  public logOutIds(url:string): Promise<any> {
    try{
      // const apiUrl = '/api/logout-session';
      return this.http.get(url,{}).toPromise();
    } catch(err){
      throw(err)
    }
  }
}
